import React from "react";

const Cancellation = () => {
    return (
        <>
            <div className="breadcrumb-bar">
                <div className="container">
                    <div className="row align-items-center text-center">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title">Cancellation Policy</h2>
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">

                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="booking-section">
                <div className="container">

                    <div className="tab-content" id="pills-tabContent">
                        <div className="tab-pane fade show active" id="pills-booking" role="tabpanel" aria-labelledby="pills-booking-tab">
                           
                                <div className="booking-title">
                                    <h3>Cancellation Policy</h3>
                                </div>

                              <div>
                              Triloki Cabs believes in helping its customers as far as possible, and has therefore a liberal cancellation policy. :
<br></br>
1. The customer agrees and acknowledges that 25% of booking amount refund shall be provided if the cancellation information is received after 24 hour of scheduled pickup, If cancellation request is received before 24 hour of the scheduled pickup, convenience charge 15% would be deducted from the amount which has been booked for travel as preauthorization or advance. The cancellation can be done over the phone or by email. All cancellation to be made against the booking ID provided at the time of booking the cab.
<br></br><br></br>2. There is no cancellation of orders placed under the same day booking.
<br></br><br></br>3. No cancellations are entertained for that products/Service that the Triloki Cabs marketing team has obtained on special occasions like Dussehra, Pongal, Diwali, New Year etc. These are limited occasion offers and therefore cancellations are not possible.

Triloki Cabs general terms:
<br></br>
1) Toll tax and parking will be paid directly to the driver in case not included in the outstation or one way booking
<br></br>2) After reaching the boarding point, waiting charge of Rs 2/- per minute will be charged after the 15 minutes waiting, these charge will be paid directly to the driver
<br></br>3) If opting for the one-way driver will not stop the car for more than 30 minutes during the journey
<br></br>4) Driver will drop the guest at the destination which will be informed by the guest while starting the journey, driver will not stop the car in between the journey except for tea and lunch break, which will be for 30 minutes max (This will be applicable if opting for one-way).
<br></br><br></br>
<h5>Refund Policy:</h5>
If you are eligible for refunds based on the "Cancellation and Returns" policy above, then the refund will be remitted back to you in 5-7 working days. In case of any issues, writes to us at contact@trilokicabs.com.

                              </div>
                            </div>

                        

                    </div>
                </div>
            </section>


        </>
    )
}

export default Cancellation;